// NEW: src/components/section-marker-slide.js
//
// Breath-moment slide shown BEFORE each concept card's content.
// Purpose: pause continuity, give the student a mental reset, make chapter
// structure visible.
//
// Visual spec: full-screen sky-blue gradient, centered title, white divider.
// Navigation is handled by the shared Next/Back bar in EnhancedLearnMode —
// this component renders the visual only (no internal buttons) so the existing
// navigation logic, lock-state, and stagger animations stay consistent with
// every other slide in the flow.

import { useEffect, useState } from "react";
import { getFontFamily } from "../constants/colors";

export function SectionMarkerSlide({ title, lang }) {
  const ff = getFontFamily(lang);

  // Light responsive sizing — desktop 32, mobile 28.
  // Uses a single viewport-width read + resize listener (cheaper than pulling
  // in the full useResponsive hook for one measurement).
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 600 : true
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const titleSize = isMobile ? 28 : 32;

  // Defensive: empty title → render nothing. enrichment.js also guards against
  // this, but double-guard so a stray title can never produce an empty screen.
  if (!title || !String(title).trim()) return null;

  return (
    <div style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 20px",
      // Sky-blue gradient — matches locked design system header style
      background: "linear-gradient(180deg, #6AAAC8 0%, #8BC4D8 100%)",
      fontFamily: ff,
      textAlign: "center",
      width: "100%",
    }}>
      {/* Title */}
      <div style={{
        fontSize: titleSize,
        fontWeight: 700,
        color: "#FFFFFF",
        lineHeight: 1.3,
        maxWidth: "80%",
        fontFamily: ff,
        letterSpacing: "-0.01em",
      }}>
        {title}
      </div>

      {/* Divider below title — 60×3px, white at 60% opacity */}
      <div style={{
        width: 60,
        height: 3,
        background: "rgba(255, 255, 255, 0.6)",
        marginTop: 16,
        borderRadius: 2,
      }} />
    </div>
  );
}
